<template>
    <div
        class="betslip-stake__row betslip-stake__total-quota"
    >
        <div class="betslip-stake__total-quota-label">
            {{ $t(totalQuotaOrNumberOfCombinationsLabel) | capitalize }}:
        </div>
        <div
            class="betslip-stake__total-quota-number"
            :title="totalQuotaOrNumberOfCombinations"
        >
            {{ totalQuotaOrNumberOfCombinations }}
        </div>
    </div>
</template>

<script>
    import { twoDecimals } from '../filters';

    export default {
        name: 'Quota',
        props: {
            isSimple: {
                type: Boolean,
                required: true,
            },
            isEmpty: {
                type: Boolean,
                required: false,
                default: false
            },
            totalCoefficient: {
                type: Number,
                default: 0,
            },
            totalNumberOfSelectedCombinations: {
                type: Number,
                default: 0,
            },
        },
        computed: {
            totalQuotaOrNumberOfCombinationsLabel() {
                return this.isSimple ? 'total quota' : 'number of combinations';
            },
            totalQuotaOrNumberOfCombinations() {
                if (this.isSimple) {
                    if (this.isEmpty) {
                        return '-';
                    }
                    return twoDecimals(this.totalCoefficient);
                }
                return this.totalNumberOfSelectedCombinations;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/betSlip/Quota.vue